export function timecodeDisplay(
  seconds: number,
  includeDays?: boolean
): string {
  let days = '';
  let hr = Math.floor(seconds / 3600);
  let min = Math.floor((seconds - hr * 3600) / 60);
  let sec = Math.floor(seconds - hr * 3600 - min * 60);
  if (includeDays) {
    hr = Math.floor((seconds % (3600 * 24)) / 3600);
    min = Math.floor((seconds % 3600) / 60);
    sec = Math.floor(seconds % 60);
  }
  const hrDisplay = hr < 10 ? `0${hr}` : `${hr}`;
  const minDisplay = min < 10 ? `0${min}` : `${min}`;
  const secDisplay = sec < 10 ? `0${sec}` : `${sec}`;

  if (includeDays) {
    const dayCount = Math.floor(seconds / 86400);
    days = dayCount < 10 ? `0${dayCount}` : `${dayCount}`;
  }

  if (includeDays) {
    return `${days}:${hrDisplay}:${minDisplay}:${secDisplay}`;
  } else {
    return `${hrDisplay === '00' ? '' : `${hrDisplay}:`}${minDisplay}:${secDisplay}`;
  }
}

/**
 * Formats a training class's course length (in hours) for display (#29794).
 * Returns 'N/A' when there is no recorded duration so labels/cells always read
 * "N/A" rather than going blank or showing "0 hrs"/"null hrs". Used on the
 * recruiter Training tab and the plant/job Training subtask list.
 */
export function formatCourseLength(hours: number | null | undefined): string {
  if (hours == null || hours <= 0) {
    return 'N/A';
  }
  return hours === 1 ? '1 hr' : `${hours} hrs`;
}

/**
 * Formats a number as US currency (USD)
 * @param value - The numeric value to format
 * @returns Formatted currency string or 'N/A' if value is null/undefined
 */
export function formatCurrency(value: number | undefined | null): string {
  if (value === undefined || value === null) {
    return 'N/A';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}
